export const WARNING_MESSAGES = {
  NO_SENSORS_FOR_INTENT: 'There are no sensors for the selected intent. Please change to continue for budget generation.'
};